// nxDialog.styles.js
export const dialogStyles = `
	dialog::backdrop {
		background: rgba(0, 0, 0, 0.3);
	}
	
	dialog:modal {
		display: flex;
		flex-direction: column;
		padding: 0;
		overflow: hidden;
		border: 1px solid darkgreen;
		outline: none;
		resize: both;
		box-shadow: 0 0 4px 0 darkgreen;
        width: 500px;
        height: fit-content;
        min-width: 330px;
        min-height: 60px;
        max-height: 100%;
    }
    
    
    
    
	div.head .rect1, div.head .rect2, div.head .rect3  {
		display: none;
		width: 50px;
		height: 100%;
	}
	div.head .rect1 {
		background-color: red;
	}
	div.head .rect2 {
		background-color: darkgreen;
	}
	div.head .rect3 {
		background-color: olive;
	}
	
	div.head {
		display: flex;
		align-items: center;
		--height: 30px;
		background-color: darkgreen;
		padding: 4px;
		cursor: move;
	}
	div.head:hover {
		filter: brightness(110%);
	}
	
	div.head span {
		font-size: 12px;
		position: relative;
	}
	
	div.head span.title {
		color: #ddd;
		margin-left: 4px;
		font-weight: bold;
	}
	
	div.head span.sub-title {
		color: #ccc;
		margin-left: 8px;
		font-style: italic;
	}
	
	div.head form {
		margin: 0;
	}
	div.head button {
		margin-right: 4px;
		background-color: transparent;
		border: none;
		color: #ccc;
		font-size: x-small;
	}
	div.head button:hover {
		cursor: pointer;
	}
	
	div.contents {
		display: flex;
		width: 100%;
		height: 100%;
		overflow: hidden;
		background-color: white;
		color: #333;
	}
	div.left {
		position: relative;
		width: 16px;
		height: 100%;
		background-color: #ddd;
		display: none;
	}
	
	div.left span {
		writing-mode: vertical-rl;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		user-select: none;
		color: #ccc;
		font-weight: 700;
		width: 100%;
		height: 100%;
		margin-left: 3px;
		margin-top: 3px;
	}
	div.close2 {
		display: none;
		position: absolute;
		right: 0;
		top: 3px;
		cursor: pointer;
		color: #666;
	}
	div.close2 svg:hover {
		color: #999;
	}
	
	div.body {
		display: flex;
		width: 100%;
		height: unset;
		--border: 3px solid #999;
		--border-top: none;
		overflow-x: hidden;
		overflow-y: auto;
		padding: 10px;
		gap: 8px;
		flex-direction: column;
	}
	
	
	
	
	ng-sphere.icon {
		margin-left: 8px;
	}
	
	.buttons {
		display: flex;
		position: absolute;
		right: 4px;
	}
	
	ng-sphere {
		position: relative;
		--width: 16px;
		--height: 16px;
		cursor: pointer;
		margin-right: 4px;
		display: flex;
	}
	ng-sphere:hover {
		filter: brightness(90%);
	}
	ng-sphere:active {
		filter: brightness(80%);
	}
	
	ng-sphere:hover::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 100%;
		background-repeat: no-repeat;
		background-position: center;
	}
	ng-sphere.apply:hover::after {
		background-size: 14px 14px;
		background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"><polyline points="2.5,7 6,10 11,3" style="fill:none;stroke:white;stroke-width:2px;" /></svg>');
	}
	
	ng-sphere.reset:hover::after {
		background-size: 12px 12px;
		background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="fill:none;stroke:white;stroke-width:2px;" focusable="false" aria-hidden="true"><path d="M10 5h5V0"></path><path d="M15 8a6.957 6.957 0 0 1-7 7 6.957 6.957 0 0 1-7-7 6.957 6.957 0 0 1 7-7 6.87 6.87 0 0 1 6.3 4"></path></svg>');
	}
	
	ng-sphere.close:hover::after {
		background-size: 12px 12px;
		background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" style="fill:none;stroke:white;stroke-width:2px;" focusable="false" aria-hidden="true" viewBox="0 0 16 16"><path d="M2 2l12 12M14 2L2 14"></path></svg>');
	}
	
	
	button {
        cursor: pointer;
    }
    
    .input-area {
        position: relative;
        height: 100%;
        --display: flex;
        textarea {
            width: 100%;
            height: 100%;
            min-height: 100px;
            padding: 8px;
            box-sizing: border-box;
            resize: none;
            border-radius: 2px;
            border-color: #ccc;
        }
        textarea:focus {
            border-color: green;
            outline: none; /* 브라우저 기본 파란색 테두리 제거 */
        }
    }
    
    .buttons-confirm {
        position: absolute;
        display: flex;
        justify-content: flex-end;
        bottom: 8px;
        right: 8px;
    }
    
    
    .buttons-confirm button {
        height: 32px;
        margin-right: 8px;
        border: none;
        outline: none;
        width: 60px;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .buttons-confirm button:hover {
        filter: brightness(90%);
    }
    .buttons-confirm button:active {
        color: #ccc;
    }
    
    button.ok {
        --display: none;
        background-color: darkgreen;
        color: white;
    }
    button.cancel {
        color: white;
        background-color: #6c757d;
    }
    
    
    
    div.msg {
        position: relative;
        height: 100%;
        font-size: 14px;
        color: #333;
        padding-bottom: 48px;
    }
    
    .reset, .apply {
        display: none;
    }
    
    
    
    :host(.classic) dialog:modal {
        border: 1px solid #007bff;
        box-shadow: 0 0 4px 0 #007bff;
    }
    
    :host(.classic) div.head {
        background-color: #007bff;
    }
    :host(.classic) div.head:hover {
        filter: brightness(110%);
    }
    
    :host(.classic) div.head span {
        font-size: 12px;
    }
    
    :host(.classic) div.head span.title {
        color: #ddd;
        margin-left: 4px;
        font-weight: bold;
    }
    
    :host(.classic) div.head span.sub-title {
        color: #ccc;
        margin-left: 8px;
        font-style: italic;
    }
    :host(.classic) div.head button {
        margin-right: 4px;
        background-color: transparent;
        border: none;
        color: #ccc;
        font-size: x-small;
    }
    
    
    
    
    :host(.rgb) dialog:modal {
        border: none;
        box-shadow: unset;
        border-top: none;
        height: 140px;
    }
    
    :host(.rgb) div.left {
        display: block;
        background-color: #ddd;
    }
    :host(.rgb) div.left span {
        color: #ccc;
    }
    :host(.rgb) div.close2 {
        display: block;
        color: #666;
    }
    :host(.rgb) div.close2 svg:hover {
        color: #999;
    }
    :host(.rgb) div.head {
        height: 4px;
        background-color: #999;
        padding: 0;
    }
    :host(.rgb) div.contents {
        height: calc(100% - 4px);
    }
    
    :host(.rgb) div.body {
        height: auto; /* 세로로 꽉 차는 현상 방지 */
        --max-height: 500px; /* 내용이 많을 때만 스크롤 생기도록 제한 */
    }
    
    :host(.rgb) div.head ng-sphere,
    :host(.rgb) div.head span,
    :host(.rgb) div.head .buttons {
        display: none;
    }
    
    :host(.rgb) div.head .rect1,
    :host(.rgb) div.head .rect2,
    :host(.rgb) div.head .rect3 {
        display: flex;
    }
    
    
    :host(.rgb) div.head:hover {
        filter: unset;
    }
    
    
    /* --- Animation Core --- */
:host {
    --nx-duration: 0.4s;
    --nx-timing: cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* 🎯 수정: 애니메이션 클래스가 붙은 경우에만 초기 opacity를 0으로 설정 */
:host(.fade) dialog,
:host(.zoom) dialog,
:host(.moveUp) dialog,
:host(.moveDown) dialog,
:host(.moveLeft) dialog,
:host(.moveRight) dialog,
:host(.roadRunner) dialog {
    opacity: 0;
}

/* shake는 애니메이션 내부에서 opacity를 다루므로 제외하거나 별도 처리 */
:host(.shake) dialog { 
    opacity: 1; 
}

/* 1. Fade (서서히 나타남) */
:host(.fade) dialog { animation: nx-fade-in var(--nx-duration) forwards; }
@keyframes nx-fade-in { from { opacity: 0; } to { opacity: 1; } }

/* 2. Zoom (커지며 나타남) */
:host(.zoom) dialog { animation: nx-zoom-in var(--nx-duration) var(--nx-timing) forwards; }
@keyframes nx-zoom-in { from { opacity: 0; transform: scale(0.5); } to { opacity: 1; transform: scale(1); } }

/* 3. Slide (상하좌우) */
:host(.moveUp) dialog { animation: nx-move-up var(--nx-duration) var(--nx-timing) forwards; }
:host(.moveDown) dialog { animation: nx-move-down var(--nx-duration) var(--nx-timing) forwards; }
:host(.moveLeft) dialog { animation: nx-move-left var(--nx-duration) var(--nx-timing) forwards; }
:host(.moveRight) dialog { animation: nx-move-right var(--nx-duration) var(--nx-timing) forwards; }

@keyframes nx-move-up { from { opacity: 0; transform: translateY(100px); } to { opacity: 1; transform: translateY(0); } }
@keyframes nx-move-down { from { opacity: 0; transform: translateY(-100px); } to { opacity: 1; transform: translateY(0); } }
@keyframes nx-move-left { from { opacity: 0; transform: translateX(100px); } to { opacity: 1; transform: translateX(0); } }
@keyframes nx-move-right { from { opacity: 0; transform: translateX(-100px); } to { opacity: 1; transform: translateY(0); } }

/* 4. Shake (상하좌우 격렬한 진동 - 에러 인지용) */
:host(.shake) dialog { 
    animation: nx-heavy-shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
    opacity: 1; 
}

@keyframes nx-heavy-shake {
    10%, 90% { transform: translate3d(-1px, -2px, 0); }
    20%, 80% { transform: translate3d(2px, 4px, 0); }
    30%, 50%, 70% { transform: translate3d(-6px, -6px, 0); }
    40%, 60% { transform: translate3d(6px, 6px, 0); }
}

/* 5. Road Runner (등장: 왼쪽에서 탄력 있게 / 퇴장: 움츠렸다가 광속 탈출) */
:host(.roadRunner) dialog { 
    animation: roadRunnerIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards; 
}

@keyframes roadRunnerIn {
    0% { transform: translateX(-1500px) skewX(30deg); opacity: 1; }
    70% { transform: translateX(30px) skewX(-10deg); opacity: 1; }
    100% { transform: translateX(0) skewX(0deg); opacity: 1; }
}

/* --- Out Animations (닫힐 때) --- */
dialog.out { pointer-events: none; }

/* Road Runner 퇴장: 슥 움츠렸다가(Anticipation) 쌩~! */
:host(.roadRunner) dialog.out { 
    animation: roadRunnerOut 0.5s cubic-bezier(0.6, -0.28, 0.735, 0.045) forwards; 
}

@keyframes roadRunnerOut {
    0% { 
        transform: translateX(0) scale(1) skewX(0deg); 
        opacity: 1; 
    }
    30% { 
        /* 예비 동작: 뒤로 살짝 갔다가 움츠러들기 */
        transform: translateX(50px) scaleX(1.2) scaleY(0.8) skewX(-20deg); 
        opacity: 1; 
    }
    100% { 
        /* 발사: 길게 늘어나며 광속 탈출 */
        transform: translateX(2000px) scaleX(4) scaleY(0.3) skewX(50deg); 
        opacity: 0; 
        filter: blur(10px); /* 👈 잔상 느낌 추가 */
    }
}

/* 일반 퇴장 (기본) */
dialog.out { animation: nx-fade-out 0.3s forwards; }
@keyframes nx-fade-out { from { opacity: 1; transform: scale(1); } to { opacity: 0; transform: scale(0.9); } }
`;